import { render, staticRenderFns } from "./ColorIntensityBox.vue?vue&type=template&id=b90fc8e6"
import script from "./ColorIntensityBox.vue?vue&type=script&lang=js"
export * from "./ColorIntensityBox.vue?vue&type=script&lang=js"
import style0 from "./ColorIntensityBox.vue?vue&type=style&index=0&id=b90fc8e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports